// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@conklin/MobiusOverrides/FormField";
import { productSelectorStyles } from "@conklin/Overrides/Components/ProductSelector";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { css } from "styled-components";

productSelectorStyles.container = {
    gap: 20,
    offsetCss: css`
        align-items: flex-start;
        &&& label + ${FormInputWrapper} {
            margin-top: 4px;
        }
    `,
};

productSelectorStyles.qtyGridItem = {
    css: css`
        & {
            padding-top: 34px;
            ${xScreen("gte", "md")} {
                flex-basis: unset;
                max-width: unset;
                margin-top: 0;
            }
            ${xScreen("lte", "md")} {
                &&&& {
                    padding-top: 12px;
                }
            }
            ${xScreen("lte", "sm")} {
                flex-basis: unset;
                max-width: unset;
                margin-top: 0;
            }
        }
        ${FormFieldStyle} {
            input {
                text-align: center;
            }
        }
    `,
};

productSelectorStyles.clearIcon = {
    size: 18,
    css: css`
        position: absolute;
        right: 32px;
        top: 37px;
        cursor: pointer;
        z-index: 1;
        :hover {
            color: ${color("common.ui10")};
        }
    `,
};

productSelectorStyles.unitOfMeasureGridItem = {
    width: [3, 2, 2, 2, 2],
    css: css`
        padding-top: 32px;
        ${xScreen("lte", "sm")} {
            padding-top: 10px;
        }
        &:empty {
            display: none;
        }
    `,
};

productSelectorStyles.searchGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-basis: unset;
        max-width: 307px;
        position: relative;
    `,
};

productSelectorStyles.buttonGridItem = {
    width: [6, 2, 2, 2, 2],
    css: css`
        padding-top: 32px;

        &&& {
            ${xScreen("lte", "md")} {
                padding-right: 0px;
                max-width: unset;
            }

            ${xScreen("lte", "sm")} {
                padding-top: 10px;
                padding-right: 10px;
                margin-top: 0;
            }
        }
    `,
};

productSelectorStyles.selectButton = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        min-width: 127px;
    `,
};

productSelectorStyles.uploadOrderGridItem = {
    width: [6, 2, 2, 2, 2],
    css: css`
        justify-content: end;
        ${xScreen("lte", "md")} {
            padding: 10px;
            padding-right: 0px;
            max-width: unset;
            flex-basis: unset;
        }
    `,
};

productSelectorStyles.wrapper = {
    css: css`
        display: flex;
    `,
};

productSelectorStyles.uploadWrapper = {
    css: css`
        min-width: 130px;
    `,
};
productSelectorStyles.unitOfMeasureSelect = {
    css: css`
        &&& {
            height: 33px;
        }
    `,
};
